import styles from '../index.less';
const NoMessage = ({ text = '暂无消息' }) => {
  return (
    <div className={styles.noMessage}>
      <img src={require('@/assets/images/messageCenter/noMessage.png')} alt="暂无消息" />
      <p>{text}</p>
    </div>
  );
};
export default NoMessage;
